<template lang="pug">
.CustomCursor(:style="style")
  p(:style="{ opacity: $store.state.hover ? 1 : 0 }") {{ $store.state.hover ? $store.state.cursorCTA : '' }}
</template>

<script>
import { mouse, lerp } from '@/js/utils'

export default {
  name: 'CustomCursor',
  data () {
    return {
      position: mouse,
      style: {
        backgroundColor: this.$store.state.inDarkPage ? this.$store.state.colors.accent : this.$store.state.colors.dark,
        color: this.$store.state.inDarkPage ? this.$store.state.colors.dark : this.$store.state.colors.light,
        transform: 'translate3d(' + mouse.x + 'px, ' + mouse.y + 'px, 0) scale3d(' + (this.$store.state.hover !== false ? '1, 1, 1' : '0.3, 0.3, 1') + ')',
        pointerEvents: this.$route.name === 'single-card' ? 'all' : 'none'
      }
    }
  },
  methods: {
    animate () {
      requestAnimationFrame(this.animate.bind(this))

      if (this.$store.state.fixCursor) {
        this.position = {
          x: lerp(this.position.x, 50 + window.innerWidth * 0.545, 0.1),
          y: lerp(this.position.y, 50 + 70, 0.1)
        }
      } else {
        this.position = {
          x: lerp(this.position.x, mouse.x, 0.1),
          y: lerp(this.position.y, mouse.y, 0.1)
        }
      }

      this.style = {
        backgroundColor: this.$store.state.inDarkPage ? this.$store.state.colors.accent : this.$store.state.colors.dark,
        color: this.$store.state.inDarkPage ? this.$store.state.colors.dark : this.$store.state.colors.light,
        transform: 'translate3d(' + this.position.x + 'px, ' + this.position.y + 'px, 0) scale3d(' + (this.$store.state.hover !== false ? '1, 1, 1' : '0.3, 0.3, 1') + ')',
        pointerEvents: this.$route.name === 'single-card' ? 'all' : 'none',
        cursor: this.$route.name === 'single-card' ? 'pointer' : 'auto'
      }
    }
  },
  mounted () {
    requestAnimationFrame(this.animate.bind(this))
    this.$el.addEventListener('click', () => {
      if (this.$route.name === 'single-card') {
        this.$store.commit('fixCursor', false)
        this.$store.commit('hover', false)
        this.$router.push({ path: '/' })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.CustomCursor {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  top: -50px;
  left: -50px;
  transition: .3s ease-out;
  z-index: 30;
  font-family: $font-rz;
  font-size: 16px;
  line-height: 1.2;

  p {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    width: 70px;
    height: 70px;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate3d(-50%, -50%, 0);
    transition: .2s ease-out .1s;
  }
}
</style>
